import { ClientStatus } from "./clients-response.interface";

export interface CreateClientInterface {
  contact_person: string | null;
  designation: string | null;
  contact_number: string | null;
  email: string | null;
  status: ClientStatus;
  created_by_id: string | null;
  updated_by_id: string | null;
  company_id: string | null;
}

export interface UpdateClientInterface {
  id: string;
  contact_person?: string | null;
  designation?: string | null;
  contact_number?: string | null;
  email?: string | null;
  status?: ClientStatus;
  updated_by_id: string | null;
  company_id?: string | null;
}